import React from 'react';
import { observer } from 'mobx-react';
import WorksheetGridItem from 'components/worksheet/worksheet_grid_item';
import GridWrapper from 'components/learning_path/grid_wrapper';

@observer
class MobilePath extends React.Component {
  render() {
    if (this.props.worksheets.length === 0) {
      return (<p>No posts found in this learning path.</p>);
    }

    return (
      <GridWrapper>
        {
          this.props.worksheets.map(item => (
            <WorksheetGridItem
              key={item.id}
              worksheet={item.worksheet}
              onSelect={this.props.onWorksheetClick}
              hidePinIcon
            />
          ))
        }
      </GridWrapper>
    );
  }
}

export default MobilePath;